import {Component, OnInit} from '@angular/core';
import {accessSecurityCodeForm} from '../../../Assets/angular/assets/data/forms/access_security_code';
import {ClientService} from '../../services/client.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-access-security-code',
    templateUrl: './access-security-code.component.html',
    styleUrls: ['./access-security-code.component.scss']
})
export class AccessSecurityCodeComponent implements OnInit {
    accessSecurityCodeForm: Array<object>;
    constructor(public clientService: ClientService, private router: Router) {
        this.accessSecurityCodeForm = accessSecurityCodeForm;
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('sequence_activate_access') && !sessionStorage.getItem('sequence_modify_phone')) {
            this.router.navigateByUrl('/activar-acceso');
        }
    }
}
